export default __webpack_public_path__ + "static/media/purple_crown.bb573b73.svg";